import React, { useEffect, useState, useLayoutEffect } from "react"
import { useAppDispatch, useAppSelector } from "hooks"

import { GlobalSidebar, TableSkeleton } from "components"
import BranchSideBar from "pages/branch/BranchSideBar"
import FilterOptions from "./FilterOptions"
import ScheduleFilterTable from "./ScheduleFilterTable"

import { filteredListBySearch, getBranches, selectBranchList } from "store/Branches/branch.slice"
import { clearSchedule, selectScheduleLoading } from "store/Schedules/schedules.slice"
import useSchedulesQueryParams from "hooks/useSchedulesQueryParams"

// let searchString1 = ""
// let timoutId: any = null

const SchedulesFilter: React.FC = () => {
	const dispatch = useAppDispatch()
	const { selected = "", setSearchParams } = useSchedulesQueryParams()
	const [searchString, setSearchString] = useState("")
	const [searchOnFields] = useState(["name"])
	const isScheduleLoading = useAppSelector(selectScheduleLoading())

	const branches = useAppSelector(selectBranchList())
	const filteredList = useAppSelector(filteredListBySearch(searchString, searchOnFields))

	useLayoutEffect(() => {
		if (selected) dispatch(clearSchedule())
	}, [selected])

	useLayoutEffect(() => {
		dispatch(clearSchedule())
	}, [])

	useEffect(() => {
		dispatch(getBranches(false))
	}, [])

	useEffect(() => {
		if (branches.length && (!selected || !filteredList.find(item => item._id === selected))) {
			handleSelected(filteredList[0]._id)
		} else if (branches.length && selected && filteredList.find(item => item._id === selected)) {
			handleSelected(selected)
		}
	}, [branches])

	// const createTimemout = (time: any) => {
	// 	return setTimeout(() => {
	// 		//setBranchSelection("")
	// 		setSearchParams({ selected: "" })
	// 		searchString1 = ""
	// 	}, time)
	// }

	// const onKeyUpHandler = (e: any) => {
	// 	if (timoutId) clearTimeout(timoutId)
	// 	searchString1 += e.key
	// 	setBranchSelection(prev => {
	// 		let prev1 = prev
	// 		prev1 += e.key

	// 		return prev1
	// 	})
	// 	setSearchParams({ selected: "" })
	// 	const filteredBranches = branches?.filter(({ name }) =>
	// 		`${name}`.toLowerCase().includes(searchString1.toLowerCase()),
	// 	)
	// 	if (filteredBranches?.length) {
	// 		setSearchParams({ selected: filteredBranches[0]._id })
	// 	}
	// 	timoutId = createTimemout(500)
	// }

	const handleSelected = (branchId: string | null): void =>
		setSearchParams({ selected: branchId || filteredList?.[0]?._id || "" })

	return (
		<>
			<GlobalSidebar>
				<div className="h-full outline-none">
					<BranchSideBar
						setSearchString={setSearchString}
						searchText={searchString}
						branches={filteredList}
						selected={selected || filteredList?.[0]?._id || ""}
						handleSelected={handleSelected}
						//onKeyUpCapture={onKeyUpHandler}
					/>
				</div>
			</GlobalSidebar>
			<FilterOptions branch={selected || filteredList?.[0]?._id || ""} />
			{!isScheduleLoading ? <ScheduleFilterTable /> : <TableSkeleton />}
		</>
	)
}

export default SchedulesFilter
